"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PolicyPagesEnum = void 0;
var PolicyPagesEnum;
(function (PolicyPagesEnum) {
    PolicyPagesEnum["Sports"] = "sports";
    PolicyPagesEnum["Casino"] = "casino";
    PolicyPagesEnum["Payments"] = "payments";
    PolicyPagesEnum["Terms"] = "terms";
    PolicyPagesEnum["Privacy"] = "privacy";
    PolicyPagesEnum["ResponsibleGaming"] = "responsible_gaming";
    PolicyPagesEnum["Cookies"] = "cookies";
    PolicyPagesEnum["SelfExclusion"] = "self_exclusion";
    PolicyPagesEnum["DisputeResolution"] = "dispute_resolution";
    PolicyPagesEnum["AntiMoneyLaundering"] = "anti_money_laundering";
    PolicyPagesEnum["FairnessRngTesting"] = "fairness_rng_testing";
    PolicyPagesEnum["Kyc"] = "kyc";
})(PolicyPagesEnum || (exports.PolicyPagesEnum = PolicyPagesEnum = {}));
//# sourceMappingURL=policies.js.map